/**
 * Constants and default configurations for PhysicalConnectionStep
 */

// Container IDs for drag and drop
export const CONTAINER_IDS = {
    SELECTED_ASSETS: 'selected-assets',
    PHYSICAL_CONNECTION: 'physical-connection'
};

// Drag sensor configuration
export const DRAG_SENSOR_CONFIG = {
    ACTIVATION_CONSTRAINT: {
        distance: 8 // Require 8px of movement before drag starts
    },
    TOUCH_ACTIVATION_CONSTRAINT: {
        delay: 250,    // Hold 250ms before drag activates on touch
        tolerance: 5   // Allow 5px of movement during the hold delay
    }
};

// Component titles (Note: These are fallback values. Components should use translation keys directly)
export const PANEL_TITLES = {
    SELECTED_ASSETS: 'Selected assets', // Fallback - use translation key in component
    PHYSICAL_CONNECTION: 'Physical connection' // Fallback - use translation key in component
};

// Empty state messages
export const EMPTY_STATE_MESSAGES = {
    PHYSICAL_CONNECTION: 'Drag and drop to arrange assets in the order they are physically connected in powertrain'
};

// UI Constants for Physical Connection components
export const PHYSICAL_CONNECTION_UI = {
    // Icon sizes for different contexts
    ICON_SIZES: {
        SMALL: { width: 16, height: 16 },
        MEDIUM: { width: 20, height: 20 },
        LARGE: { width: 22, height: 22 },
        EXTRA_LARGE: { width: 32, height: 32 }
    },

    // SVG validation icon size
    VALIDATION_ICON_SIZE: { width: 16, height: 16 }
};

// Cursor styles for draggable items
export const CURSOR_STYLE = {
    DRAGGABLE: 'grab',
    NOT_DRAGGABLE: 'not-allowed'
};

// Touch action styles for draggable items
export const TOUCH_ACTION = {
    DRAGGABLE: 'none',
    NOT_DRAGGABLE: 'auto'
};

// Allowed asset types for physical connection
// Note: de_pump is kept last so existing index references (e.g. ALLOWED_ASSET_TYPES[2] === 'genericmachine') stay valid
export const ALLOWED_ASSET_TYPES = ['motor', 'drive', 'genericmachine', 'de_pump'];

export const GENERIC_MACHINE_SUBTYPES = ['gearbox', 'pump', 'fan', 'bearing'];

// Minimum number of not connected assets required to show conversion to location banner
export const MIN_ASSETS_FOR_CONVERSION_BANNER = 6;

// Add Gearbox dialog defaults
export const ADD_GEARBOX_DEFAULTS = {
    ASSET_TYPE: 'GenericMachine',
    ASSET_TYPE_DISPLAY: 'General Machinery',
    SUB_TYPE: 'Gearbox',
    SUB_TYPE_DISPLAY: 'Gearbox',
    DEFAULT_ASSET_GROUP_DISPLAY: 'Default asset group',
    MAX_ASSET_NAME_LENGTH: 100,
    // Prefix for temporary IDs of unsaved gearboxes
    TEMP_ID_PREFIX: 'temp-gearbox-'
};
